import { render } from "./DestinationItem.vue?vue&type=template&id=c4ac0048&scoped=true"
import script from "./DestinationItem.vue?vue&type=script&lang=js"
export * from "./DestinationItem.vue?vue&type=script&lang=js"

import "./DestinationItem.vue?vue&type=style&index=0&id=c4ac0048&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4ac0048"]])

export default __exports__